<template>
  <div id="app">
    <div id="container">
      <TextSection/>
      <AnimatedSideBar backgroundColor="#2179B0"/>
    </div>
  </div>
</template>

<script>
import TextSection from './components/TextSection.vue'
import AnimatedSideBar from './components/AnimatedSideBar.vue'

export default {
  name: 'app',
  components: {
    TextSection,
    AnimatedSideBar
  }
}
</script>

<style>
html, body, #container, #app {
  margin: 0;
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #474747;
}

#container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-between;
  height: 100%;
}

@media only screen and (min-width: 800px) {
  html, body, #container, #app {
    overflow: hidden;
  }
}
</style>
